import { KnockoutView } from '../../../components/worldcup/KnockoutView/KnockoutView';

export default function WorldCupKnockoutRoute() {
  return <KnockoutView />;
}
